import { build } from '@didi/webx-js'
import { getUrlParams } from '../../utils'
/**
 * @description 下载文件
 * @author wangfupeng
 */

const QUERY = getUrlParams()

export default function (eventData = {}) {
    // aio 全局变量
    const downloadUrl = eventData.downloadUrl
    if (!downloadUrl) {
        console.error('download url is null or undefined')
        return
    }

    // 手机号、邮箱、onetravel、diditravel协议直接跳转
    if (/^(onetravel|diditravel|tel|mailto).*/i.test(downloadUrl)) {
        location.href = downloadUrl
        return
    }

    const newDownloadUrl = build(downloadUrl, QUERY)
    window.location.href = newDownloadUrl
}
